import React from "react";
import "../../css/pages/affiliate.css";
import PropTypes from 'prop-types';
import { NavLink } from "react-router-dom";
import Select from 'react-select';

import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';

import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import * as Constants from '../../data/constants';
import { Store } from 'react-notifications-component';
import { getLocalStorageValue, sorting } from "../../util/util";
import axios from 'axios';
import CreatableSelect from 'react-select/creatable';
import { increase_brightness } from "../../components/customization/customization";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          {children}
        </Box>
      )}
    </div>
  );
}


TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const NewAffiliatePage = props => {
  const [tabValue, setTabValue] = React.useState(0);
  const [manualUseState, setManualUseState] = React.useState(false);

  const [email, setEmail] = React.useState("");
  const [newPassword, setNewPassword] = React.useState("");
  // const [username, setUsername] = React.useState("");
  const [companyName, setCompanyName] = React.useState("");
  // const [deviceID, setDeviceId] = React.useState("");
  const [contactPerson, setContactPerson] = React.useState("");
  const [contactMobile, setContactMobile] = React.useState("");
  const [contactEmail, setContactEmail] = React.useState("");
  const [managerID, setManagerID] = React.useState("1");
  const [affiliateStatus, setAffiliateStatus] = React.useState("active");
  const [skype, setSkype] = React.useState("");
  // const [site, setSite] = React.useState("");
  const [note, setNote] = React.useState(null);
  // const [tags, setTags] = React.useState("");
  const [address, setAddress] = React.useState({country:"India"});
  const [managerList, setManagerList] = React.useState([]);

  const [saveButtonDisabled, setSaveButtonDisabled] = React.useState(true);
  const [requiredString, setRequireString] = React.useState("");
  
  const [showResponsePopup, setShowResponsePopup] = React.useState(false);
  const [responsePopup, setResponsePopup] = React.useState(false);

  const [responsePopupError, setResponsePopupError] = React.useState(false);

  const [globalPostback,setGlobalPostback] = React.useState(false);
  const [disableAddButton, setDisableAddButton] = React.useState(false);
  const [tags, setTags] = React.useState([]);
  const [tagsOptions, setTagsOptions] = React.useState([]);

  const handleTabValue = (event, newValue) => {
    setTabValue(newValue);
  };

  const addAffiliateRequest = async() => {
    setDisableAddButton(true)
    var tagList = []
    for(var index in tags){
      tagList.push(tags[index].value)
    }
    await axios({
      method: 'POST',
      url: "".concat(Constants.PROTOCOL,Constants.HOST,Constants.API_USER_PATH,Constants.ADD_AFFILIATE),
      headers:{
          Authorization:getLocalStorageValue('adminPanelLoginData').token,
          "Content-Type":"application/json",
      },
      data:{
        "email":email,
        "password":newPassword,
        // "username": username,
        "company_name": companyName,
        // "device_id": deviceID,
        "address": address,
        "affiliate_status": affiliateStatus,
        "contact_number" : contactMobile ? contactMobile : null,
        "contact_person" : contactPerson ? contactPerson : null,
        "contact_email" : contactEmail ? contactEmail : null,
        "manager_id": managerID ? managerID.value : 1,
        "note": note ? note : null,
        "skype_id" : skype ? skype : null,
        "tags": tagList
        }
      })
    .then((resp)=>{
      if(resp.data.result && resp.data.result.affiliate)
        { 
          setResponsePopupError(false);
          if(globalPostback){
            editPostbackRequest(resp.data.result.affiliate.id)
          }
          else{
            Store.addNotification({
              title: "Success!",
              message: "Affiliate added successfully",
              type: "success",
              insert: "top",
              container: "top-right",
              animationIn: ["animate__animated", "animate__fadeIn"],
              animationOut: ["animate__animated", "animate__fadeOut"],
              dismiss: {
                duration: 1000,
                onScreen: true
              },
              onRemoval: (id, removedBy) => {
                window.location.href = "/affiliates/management"
                setDisableAddButton(false)
              }
            });
          }
          }
      else{
        Store.addNotification({
          title: "Error!",
          message: typeof resp.data.result === "string" ? resp.data.result : "Some error occured",
          type: "warning",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true
          }
        });
        setDisableAddButton(false)
        }
      }
    )
    .catch(function (error) {
      setDisableAddButton(false)
      setResponsePopupError(true)
      if (error.response) {
        // Request made and server responded
        Store.addNotification({
          title: "Error!",
          message: error.response.data.result,
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true
          }
        });
        setResponsePopup(error.response.data.result);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else {
        // Something happened in setting up the request that triggered an Error
        setResponsePopup(JSON.stringify({error:error.message}));
        console.log('Error', error.message);
      }
  
    });
  }

  const editPostbackRequest = async(affiliateid) => {
    await axios({
      method: 'POST',
      url: "".concat(Constants.PROTOCOL,Constants.HOST,Constants.API_USER_PATH,"postbacks/add"),
      headers:{
          Authorization:getLocalStorageValue('adminPanelLoginData').token,
          "Content-Type":"application/json",
      },
      data:{
        "affiliate_id" : affiliateid, 
        "postback_url" : globalPostback
        }
      })
    .then((resp)=>{
      if(resp.data.result && typeof resp.data.result !== ("string"))
        { 
          setDisableAddButton(false);
          Store.addNotification({
          title: "Success!",
          message: "Affilate added and Postback added successfully",
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 1000,
            onScreen: true
          },
          onRemoval: (id, removedBy) => {
            window.location.href = "/affiliates/management/"
          }
        });}
      else{
          setDisableAddButton(false);
          Store.addNotification({
            title: "Error!",
            message: typeof resp.data.result === "string" ? resp.data.result : "Some error occured",
            type: "warning",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 3000,
              onScreen: true
            }
          });
        }
      }
    )
    .catch(function (error) {
      setDisableAddButton(false);
      setResponsePopupError(true)
      if (error.response) {
        // Request made and server responded
        setResponsePopup(error.response.data.result);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else {
        // Something happened in setting up the request that triggered an Error
        setResponsePopup(JSON.stringify({error:error.message}));
        console.log('Error', error.message);
      }
  
    });
  }

  const getManagers = async() => {
    await axios({
        method: 'GET',
        url: "".concat(Constants.PROTOCOL,Constants.HOST,Constants.API_USER_PATH,"manager","/","details"),
        headers:{
            Authorization:getLocalStorageValue('adminPanelLoginData').token
        },
    })
    .then(resp => {
      let managerlist = []
      for (var item in resp.data.result){
            managerlist.push({label:resp.data.result[item][Object.keys(resp.data.result[item])[0]],value:Object.keys(resp.data.result[item])[0]})
          }
          sorting(managerlist,'label',false,true)
          setManagerList(managerlist)
    })
    .catch(err => {
        console.error(err);
    })
};

const getTags = async() => {
  await axios({
      method: 'GET',
      url: "".concat(Constants.PROTOCOL,Constants.HOST,Constants.API_USER_PATH,"affiliate/tags/details"),
      headers:{
          Authorization:getLocalStorageValue('adminPanelLoginData').token
      },
  })
  .then(resp => {
    let managerlist = []
    for (var item in resp.data.result){
          managerlist.push({label:resp.data.result[item][Object.keys(resp.data.result[item])[0]],value:Object.keys(resp.data.result[item])[0]})
        }
        sorting(managerlist,'label',false,true)
        setTagsOptions(managerlist)
  })
  .catch(err => {
      console.error(err);
  })
};
  if (!manualUseState){
    getManagers();
    getTags();
    setManualUseState(true);
  }

  const handleNewPassword = (e) => {
    var lowerCaseLetters = /[a-z]/g;
    var upperCaseLetters = /[A-Z]/g;
    var specialCharacter = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
    var number = /[0-9]/g;
    var required_string_list = []
    if (e.target.value.match(specialCharacter) 
        && e.target.value.match(number) 
        && e.target.value.match(lowerCaseLetters) 
        && e.target.value.match(upperCaseLetters)
        && e.target.value.length>=8
        && e.target.value.length<=30
        ){  
            setRequireString("")
            setNewPassword(e.target.value)
        }

    if(e.target.value.length<8){
        required_string_list.push("Less than 8 characters")
    }
    else if(e.target.value.length>30){
        required_string_list.push("More than 30 characters")
    }
    else {
        if(!e.target.value.match(specialCharacter)){
            required_string_list.push("Special Character")
        }
        if(!e.target.value.match(number)){
            required_string_list.push("Number")
        }
        if(!e.target.value.match(lowerCaseLetters)){
            required_string_list.push("Lower case alphabet")
        }
        if(!e.target.value.match(upperCaseLetters)){
            required_string_list.push("Upper case alphabet")
        }
    }
    if (required_string_list.length!==0){
        var requiredString = ""
        for (var item in required_string_list){
            requiredString += required_string_list[item] + ", "
        }
        requiredString = requiredString.slice(0,(requiredString.length-2))
        if (requiredString!=="Less than 8 characters"){
            requiredString+=" is missing"
        }
        setRequireString(requiredString)
        setNewPassword(e.target.value)
    }
  }

  const specialCharacter = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
  const number = /[0-9]/g;
  const email_regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const skype_regex = /[a-zA-Z][a-zA-Z0-9.,\-_]{5,31}/;
  const changeCountryValue = (e) => {
    setAddress({...address ,country:e.value})
  }

  const countriesOptions = Constants.COUNTRIES_LIST.map((item,index)=>{
    return (
      {label:item,value:item}
    )
  });

  if (companyName !== "" 
      && !companyName.match(specialCharacter) 
      && email !== "" 
      && newPassword !== "" 
      && contactPerson!==""
      && (contactMobile === "" || contactMobile.match(number))
      && (contactEmail === "" || contactEmail.match(email_regex))
      ){
    if (saveButtonDisabled===true){
        setSaveButtonDisabled(false)
    }
  }
  else{
    if (saveButtonDisabled===false){
      setSaveButtonDisabled(true)
    }
  }
  
  const handleSaveAndContinueAffiliateButton = () => {
    handleTabValue("continue",(tabValue<1 ? tabValue+1 : 0))
  }
  const handleSaveAffiliateButton = () => {
    addAffiliateRequest()
  }
  
  const general = () => {
    return(
      <div style={{height:"100%",overflowY:"auto",marginLeft:"1%",marginTop:"2%"}}>
        
        <div style={{display:"flex"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>EMAIL *</div>
          <div style={{transform:"scale(0.8)",width:"40%"}}><TextField fullWidth size="small" value={email ? email : ""} onChange={(e)=>{setEmail(e.target.value)}}/></div>
          {(email ? !email.match(email_regex)? <div style={{fontSize:"11px",display:"flex",alignItems:"center",color:"red"}}> Email id is not in correct form.</div> : null  : null)}
        </div>

        <div style={{display:"flex"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>PASSWORD *</div>
          <div style={{transform:"scale(0.8)",width:"40%"}}><TextField fullWidth size="small" value={newPassword ? newPassword : ""} onChange={handleNewPassword}/></div>
          <label style={{fontSize:"12px",color:"red",marginTop:"1%"}}>{requiredString!=="" ? requiredString : ""}</label>
        </div>

        <div>
              
        </div>
        <div style={{display:"flex"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>Company Name *</div>
          <div style={{transform:"scale(0.8)",width:"40%"}}><TextField fullWidth size="small" value={companyName ? companyName : ""}  onChange={(e)=>{setCompanyName(e.target.value)}}/></div>
          {(companyName ? companyName.match(specialCharacter) ? <div style={{fontSize:"11px",display:"flex",alignItems:"center",color:"red"}}> Special characters are not allowed in company name.</div> : null  : null)}
        </div>

        <div style={{display:"flex"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>Contact Person Name * </div>
          <div style={{transform:"scale(0.8)",width:"40%"}}><TextField fullWidth size="small" value={contactPerson ? contactPerson : ""}  onChange={(e)=>{setContactPerson(e.target.value)}}/></div>
          {(contactPerson ? contactPerson.match(specialCharacter) || contactPerson.match(number) ? <div style={{fontSize:"11px",display:"flex",alignItems:"center",color:"red"}}> Special characters and numbers are not allowed in contact person name.</div> : null  : null)}
        </div>
        {/* <div style={{display:"flex"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>Username *</div>
          <div style={{transform:"scale(0.8)",width:"40%"}}><TextField fullWidth size="small" onChange={(e)=>{setUsername(e.target.value)}}/></div>
        </div> */}
        <div style={{display:"flex",marginTop:"4px",marginBottom:"4px"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>Affiliate Status</div>
          <div style={{width:"32%",height:"50%",marginLeft:"4%"}}>
            <select style={{width:"100%",height:"30px",border: "1px solid rgb(225,225,225)"}} value={affiliateStatus} onChange={(e)=>{setAffiliateStatus(e.target.value)}}>
              <option value={"active"}>Active</option>
              <option value={"notactive"}>Not Active</option>
              <option value={"banned"}>Banned</option>
              <option value={"moderation"}>On Moderation</option>
            </select>
          </div>
        </div>
        <div style={{display:"flex"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>Manager</div>
          <div style={{transform:"scale(0.8)",width:"40%"}}>
            <Select options={managerList}
              onChange={(e)=>{setManagerID(e)}}
              menuPortalTarget={document.body} 
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }),
                        option: styles => ({...styles,fontSize:"12px"}) }}/>
          </div>
        </div>

        <div style={{display:"flex",marginTop:'10px'}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>Tags</div>
          <div style={{transform:"scale(0.8)",width:"40%"}}>
              <CreatableSelect
                isMulti
                placeholder='Tags'
                options={tagsOptions}
                value={tags}
                onChange={(e)=>{setTags(e)}}
                menuPortalTarget={document.body} 
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }),
                            control: (base,state) => ({
                                ...base,
                                // maxHeight: 100,
                                minHeight: 30,
                                overflowY: "auto",
                                border: state.isFocused ? '1px solid '+localStorage.getItem('ambientColor') : '1px solid grey',
                                boxShadow: state.isFocused ? '0 0 3px 1px '+localStorage.getItem('ambientColor') : 0,
                                '&:hover': {
                                    border: state.isFocused ? '1px solid '+localStorage.getItem('ambientColor') : '1px solid '+localStorage.getItem('ambientColor'),
                                    boxShadow: state.isFocused ? '0 0 1px 1px '+localStorage.getItem('ambientColor') : '0 0 1px 1px '+localStorage.getItem('ambientColor'),
                                }
                            }),
                            option: (styles, {isFocused, isSelected}) => ({
                                ...styles,
                                fontSize:'11px',
                                background: isFocused
                                    ? localStorage.getItem('ambientColor')
                                    : isSelected
                                        ? increase_brightness(localStorage.getItem('ambientColor'),10)
                                        : undefined,
                                zIndex: 1
                            }),
                        }}
            />
          </div>
        </div>
        {/* <div style={{display:"flex"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>Site</div>
          <div style={{transform:"scale(0.8)",width:"40%"}}><TextField fullWidth size="small" onChange={(e)=>{setSite(e.target.value)}}/></div>
        </div> */}
        <div style={{display:"flex"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>Note</div>
          <div style={{transform:"scale(0.8)",width:"40%"}}><TextField multiline rows={4} fullWidth size="small" value={note ? note : ""} onChange={(e)=>{setNote(e.target.value)}}/></div>
        </div>
      </div>
    )
  }

  const contact = () => {
    return(
      <div style={{height:"100%",overflowY:"auto",marginLeft:"1%",marginTop:"2%"}}>
        
        <div style={{display:"flex"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>Skype</div>
          <div style={{transform:"scale(0.8)",width:"40%"}}><TextField fullWidth size="small" value={skype ? skype : ""}  onChange={(e)=>{setSkype(e.target.value)}}/></div>
          {(skype ? !skype.match(skype_regex)? <div style={{fontSize:"11px",display:"flex",alignItems:"center",color:"red"}}> Skypeid is incorrect.</div> : null  : null)}
        </div>

        <div style={{display:"flex"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>Contact Person Number</div>
          <div style={{transform:"scale(0.8)",width:"40%"}}><TextField fullWidth size="small" value={contactMobile ? contactMobile : ""} onChange={(e)=>{setContactMobile(e.target.value)}}/></div>
          {(contactMobile ? !contactMobile.match(number) ? <div style={{fontSize:"11px",display:"flex",alignItems:"center",color:"red"}}> Alphabets and special characters are not allowed in contact person name.</div> : null  : null)}
        </div>
        <div style={{display:"flex"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>Contact Person Email</div>
          <div style={{transform:"scale(0.8)",width:"40%"}}><TextField fullWidth size="small" value={contactEmail ? contactEmail : ""} onChange={(e)=>{setContactEmail(e.target.value)}}/></div>
          {(contactEmail ? !contactEmail.match(email_regex)? <div style={{fontSize:"11px",display:"flex",alignItems:"center",color:"red"}}> Email id is not in correct form.</div> : null  : null)}
        </div>
        <div style={{display:"flex"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>Address 1</div>
          <div style={{transform:"scale(0.8)",width:"40%"}}><TextField fullWidth size="small" multiline rows={2} value={address ? address.address1 ? address.address1 : "" : ""} onChange={(e)=>{setAddress({...address ,address1:e.target.value})}}/></div>
        </div>
        <div style={{display:"flex"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>Address 2</div>
          <div style={{transform:"scale(0.8)",width:"40%"}}><TextField fullWidth size="small" multiline rows={2} value={address ? address.address2 ? address.address2 : "" : ""} onChange={(e)=>{setAddress({...address ,address2:e.target.value})}}/></div>
        </div>
        <div style={{display:"flex"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>City</div>
          <div style={{transform:"scale(0.8)",width:"40%"}}><TextField fullWidth size="small" value={address ? address.city ? address.city : "" : ""} onChange={(e)=>{setAddress({...address ,city:e.target.value})}}/></div>
        </div>
        <div style={{display:"flex"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>Country</div>
          <div style={{transform:"scale(0.8)",width:"40%"}}>
            <Select className="selectCountryList" options={countriesOptions}
              defaultValue={address ? address.country ? {label:address.country,value:address.country} : null : null}

              onChange={changeCountryValue}
              menuPortalTarget={document.body} 
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }),
                      option: styles => ({...styles,fontSize:"12px"}) }}/>
          </div>
        </div>
        <div style={{display:"flex"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>Zip Code</div>
          <div style={{transform:"scale(0.8)",width:"40%"}}><TextField fullWidth size="small" value={address ? address.zipcode ? address.zipcode : "" : ""} onChange={(e)=>{setAddress({...address ,zipcode:e.target.value})}}/></div>
        </div>
      </div>
    )
  }

  const postback = () => {
    return(
      <div style={{height:"100%",overflowY:"auto",marginLeft:"1%",marginTop:"2%"}}>
        
        <div style={{display:"flex"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>Global Postback</div>
          <div style={{transform:"scale(0.8)",width:"80%"}}><TextField multiline fullWidth size="small" onChangeCapture={(e)=>{setGlobalPostback(e.target.value)}} /></div>
        </div>

        <div style={{display:"flex"}}>
          <div style={{justifyContent:"right",alignItems:"center",display:"flex",fontSize:"13px",fontWeight:"600",color:"rgb(100,100,100)",width:"20%"}}>Local Postback</div>
          <div style={{transform:"scale(0.8)",width:"80%"}}>
            <TextField multiline fullWidth size="small" disabled/>
          </div>
        </div>
        
      </div>
    )
  }
  return (
     <div className="row">
        <div className="columnData" style={{width:"95%",background:"white",height:"80vh"}}>
        <div style={{background:"white",width:"auto",height:"7%"}}>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs 
              TabIndicatorProps={{style: {background:'orange',backgroundColor:'orange'}}}
              value={tabValue} 
              onChange={handleTabValue} 
              aria-label="basic tabs example">
              <Tab label={<span className={tabValue===0? 'Active' : 'Inactive'}>General</span>}/>
              <Tab label={<span className={tabValue===1? 'Active' : 'Inactive'}>Contact</span>}/>
              <Tab label={<span className={tabValue===2? 'Active' : 'Inactive'}>Postback</span>}/>
            </Tabs>
          </Box>
          </Box>
          
        </div>
        <div style={{height:"80%",width:"100%",background:"white",overflowY:"auto"}}>
         
          <TabPanel value={tabValue} index={0}>
            {general()}
          </TabPanel>
          <TabPanel value={tabValue} index={1}>
            {contact()}
          </TabPanel>
          <TabPanel value={tabValue} index={2}>
            {postback()}
          </TabPanel>
          
        </div>

        <div style={{display:"flex",alignItems:"center",height:"7%",width:"90%"}}>
          <div style={{display:"flex",marginLeft:"20%"}}>
            <Button variant="contained" color="warning" onClick={handleSaveAndContinueAffiliateButton}>SAVE AND CONTINUE</Button>
          </div>
            <Button style={{marginLeft:"2%"}} variant="contained" color="warning" onClick={handleSaveAffiliateButton} disabled={saveButtonDisabled || disableAddButton}>ADD</Button>
          <div style={{marginLeft:"2%"}}>
            <NavLink style={{textDecoration:"none",color:"black"}} to={"/affiliates/management"}>
              <Button variant="text">Cancel</Button>
            </NavLink>          
          </div>
        </div>
      </div>
      {showResponsePopup && 
          <div className="popup-box">
            <div className="box-response">
              <div className="popupHeader" >{"RESULT"}</div>
              <div style={{borderBottom:"2px solid orange"}}></div>
                <div className="popupData">
                  {responsePopup}
                </div>
                {
                  !responsePopupError && 
                    <NavLink style={{textDecoration:"none",color:"black"}} to={"/affiliates/management"}>
                      <div className="close-icon-response" onClick={()=>{setShowResponsePopup(false)}}>X</div>
                    </NavLink>
                  }
                {
                  responsePopupError &&
                    <div className="close-icon-response" onClick={()=>{setShowResponsePopup(false)}}>X</div>
                }
            </div>
          </div>
      }
    </div>
  );
};
 
export default NewAffiliatePage;